import React, {
  useState,
  useEffect,
  Children,
  cloneElement,
  CSSProperties,
} from 'react'

const prefixCls = 'ivu-row'
export interface LoongInRowProps {
  children?: any
  type?: string // 无效，强制都是：flex
  align?: string //flex 布局下的垂直对齐方式，可选值为 top、middle、bottom	String
  justify?: string //布局下的水平排列方式，可选值为 start、end、center、space-around、space-between
  gutter?: number //栅格间距，单位 px，左右平分 类型：Number 默认：0
  wrap?: boolean //是否自动换行	类型：Boolean	默认：true
  className?: string //自定义的class名称
  style?: CSSProperties
}
export const LoongInRow = ({
  children,
  type, // 无效，强制都是：flex
  align, //flex 布局下的垂直对齐方式，可选值为 top、middle、bottom	String
  justify, //布局下的水平排列方式，可选值为 start、end、center、space-around、space-between
  gutter, //栅格间距，单位 px，左右平分 类型：Number 默认：0
  wrap, //是否自动换行	类型：Boolean	默认：true
  className, //自定义的class名称
  style,
}: LoongInRowProps) => {
  const [classes, setClasses] = useState('')
  const [styles, setStyles] = useState({})

  useEffect(() => {
    const classList = [
      `${prefixCls}`,
      !!type ? `${prefixCls}-${type}` : '',
      !!align && type ? `${prefixCls}-${type}-${align}` : '',
      !!justify && type ? `${prefixCls}-${type}-${justify}` : '',
      !!align ? `${prefixCls}-${align}` : '',
      !!justify ? `${prefixCls}-${justify}` : '',
      !!className ? `${className}` : '',
      !wrap ? `${prefixCls}-no-wrap` : '',
    ]
    let newclasses = ''
    classList.forEach((c) => {
      if (c) newclasses += c + ' '
    })
    setClasses(newclasses)
  }, [type, align, justify, className])

  useEffect(() => {
    let newstyle = {}
    if (gutter !== 0) {
      newstyle = {
        marginLeft: gutter / -2 + 'px',
        marginRight: gutter / -2 + 'px',
      }
    }
    setStyles(newstyle)
  }, [gutter])

  const childrenWithProps = Children.map(children, (child: any) => {
    return cloneElement(child, {
      gutter: gutter,
    })
  })
  return (
    <div className={classes} style={{ ...styles, ...style }}>
      {childrenWithProps}
    </div>
  )
}
